import runAfterPageLoad from "../runAfterPageLoad";

export default function acceptDisclaimer() {
  runAfterPageLoad(() => {
    const element = document.getElementById("disclaimer");
    const token = new URLSearchParams(window.location.search).get(
      "reset_password_token"
    );
    if (!element || !token) return;

    element.addEventListener("change", () => {
      $.ajax({
        url: "/accept_disclaimer",
        type: "POST",
        data: {
          reset_password_token: token,
          enabled: element.checked,
        },
      });
    });
  });
}
